<template>
  <div class="body">
    <div class="main">
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    > -->
      <ul>
        <li>
          <div class="li_top">
            <div class="title">
              {{data.projectName}}
            </div>
          </div>
          <div class="li_content">
            <div class="lebal_item">
              <div class="lebal">单位工程：</div>
              <div class="lebal_test"> {{data.subProjectName}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">建设单位：</div>
              <div class="lebal_test"> {{data.buildUnit}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">施工单位：</div>
              <div class="lebal_test"> {{data.constructionUnit}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">设计单位：</div>
              <div class="lebal_test"> {{data.designUnit}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">监理单位：</div>
              <div class="lebal_test"> {{data.supervisionUnit}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">其他单位：</div>
              <div class="lebal_test"> {{data.otherUnit}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">分户验收时间：</div>
              <div class="lebal_test"> {{data.acceptanceDate}}</div>
            </div>
            <div class="lebal_item">
              <div class="lebal">描述：</div>
              <div class="lebal_test"></div>
            </div>
            <div class="footer_box">
              {{data.noticeContent}}
            </div>
          </div>
        </li>

      </ul>
      <!-- </van-list>
            </van-pull-refresh> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      value: "",
      data: null,
    };
  },
  mounted() {
    this.data = JSON.parse(this.$route.query.item);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.body {
  text-align: left;
}
.main {
  ul {
    li {
      background-color: #fff;
      padding: 0 30px;
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 20px;
      .li_top {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eeeeee;
        img {
          width: 60px;
          height: 60px;
        }
        .title {
          flex: 1;
          box-sizing: border-box;
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #222222;
          line-height: 34px;
        }
      }
      .li_content {
        width: 100%;
        padding: 20px 0 20px 0;
        position: relative;
        .icon_status {
          position: absolute;
          right: 0;
          top: 20px;
          width: 140px;
          height: 140px;
        }
        .lebal_item {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          margin-bottom: 20px;
          .lebal_test {
            flex: 1;
            color: #666666;
            font-size: 28px;
          }
        }
        .footer_box {
          width: 100%;
          background-color: #f5f5f5;
          padding: 20px 30px;
          min-height: 50px;
          box-sizing: border-box;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }
      }
    }
  }
}
</style>